import { LinkConfig } from '../deep-links/LinkConfig'

/**
 * Get the config for a universal link
 * @param url - The URL to parse
 * @returns The config for the universal link
 * @throws Error if the URL is invalid
 */
export const getUniversalLinkConfig = (url: string) => {
  if (!url.includes('/link/')) {
    throw new Error('Invalid universal link')
  }

  const parsed = new URL(url)
  const pathParts = parsed.pathname.split('/')
  const linkIndex = pathParts.indexOf('link')

  if (linkIndex === -1 || !pathParts[linkIndex + 1]) {
    throw new Error('Missing link action in path')
  }

  const action = pathParts[linkIndex + 1]
  const config = LinkConfig[action as keyof typeof LinkConfig]

  if (!config) {
    throw new Error(`Unsupported link action: ${action}`)
  }

  return config
}
